import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-pw-change',
  templateUrl: './pw-change.component.html',
  styleUrls: ['./pw-change.component.scss'],
})
export class PwChangeComponent implements OnInit {
  email: string;

  currentPw = '';
  newPw = '';
  confirmPw = '';
  nowPwExpressionChk = false;
  pwExpressionChk = false;
  rePwExpressionChk = false;

  constructor(private modalService: NgbModal, private auth: AuthService, private spinner: NgxSpinnerService, private alertService: AlertService) {}

  ngOnInit(): void {
    this.email = localStorage.getItem('email');
    console.log('email', this.email);
  }

  pwExpression() {
    if (!this.newPw) {
      return;
    }

    const regexp: RegExp = /^(?=.*[a-zA-Z])(?=.*[0-9]).{6,25}$/;

    if (regexp.test(this.newPw) && this.newPw.length >= 6) {
      this.pwExpressionChk = true;
    } else {
      this.pwExpressionChk = false;
    }
  }

  rePwExpression() {
    if (!this.confirmPw) {
      return;
    }

    if (this.newPw === this.confirmPw) {
      this.rePwExpressionChk = true;
    } else {
      this.rePwExpressionChk = false;
    }
  }

  disabledCheck() {
    const condition = !this.currentPw || !this.pwExpressionChk || !this.confirmPw;

    return condition ? true : false;
  }

  doChangePassword() {
    this.spinner.show();
    this.auth
      .loginUser({ email: this.email, password: this.currentPw })
      .then(() => {
        if (this.rePwExpressionChk) {
          this.auth.changePassword(this.confirmPw).then(() => {
            this.spinner.hide();
            this.alertService.successmsg('비밀번호를 변경했습니다', '').then(() => {
              this.modalService.dismissAll();
            });
          });
        } else {
          this.spinner.hide();
          this.alertService.errormsg('비밀번호가 일치하지 않습니다.', '');
        }
      })
      .catch(error => {
        console.log(error);
        this.spinner.hide();
        if (error.code == 'auth/wrong-password') {
          this.alertService.errormsg('현재 비밀번호가 틀렸습니다.', '');
        }
      });
  }

  // 모달 닫기
  close() {
    this.modalService.dismissAll();
  }
}
